import snsAxiosClient from '../common/http/http-sns';
import { get, invoke, isEmpty, random, range } from 'lodash';
import { dvid } from '../utils/constants';

function searchProducts(environmentVariables, user, keyword, upcomingOrder) {
  const headers = get(environmentVariables, 'SEARCH_API_HEADERS_GET', {});
  const banner = get(headers, 'x-swy-banner', '');
  const options = {
    headers: {
      ...headers,
    },
  };

  const params = new URLSearchParams();
  if (!isEmpty(keyword)) {
    params.append('q', keyword);
  }
  params.append(
    'request-id',
    Math.floor(900 * Math.random() + 100).toString() + Date.now() + Math.floor(900 * Math.random() + 100).toString(),
  );
  params.append('url', get(window, 'location.origin', ''));
  params.append('pageurl', get(window, 'location.origin', ''));
  params.append('pagename', 'search');
  params.append('rows', '30');
  params.append('start', '0');
  params.append('search-type', 'keyword');
  params.append('featured', 'false');
  params.append('dvid', dvid);
  params.append('channel', get(upcomingOrder, 'fulfillment.fulfillmentType') === 'DUG' ? 'pickup' : 'delivery'); //sns preferred channel
  params.append('visitorId', invoke(window, 'AB.COMMON.getCookie', 'absVisitorId'));
  params.append('uuid', get(user, 'UUID', ''));
  //params.append('pgm', 'intg-search'); // Commenting this field as per search team's request to supress the marketplace items
  params.append('banner', banner);
  params.append('includeOffer', 'true');
  params.append('storeid', get(upcomingOrder, 'storeId', '')); //sns preffered store id

  return snsAxiosClient(options).get(`${environmentVariables.SNS_PRODUCT_SEARCH}`, {
    params,
  });
}

export default searchProducts;
